import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getConf } from '@jbrowse/core/configuration';
import { Menu } from '@jbrowse/core/ui';
// locals
import Tooltip from './Tooltip';
import BlockMsg from './BlockMsg';
import LinearBlocks from './LinearBlocks';
var useStyles = makeStyles()({
  display: {
    position: 'relative',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    width: '100%',
    minHeight: '100%'
  }
});
var BaseLinearDisplay = observer(function (props) {
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var theme = useTheme();
  var ref = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    clientRect = _useState2[0],
    setClientRect = _useState2[1];
  var _useState3 = useState([0, 0]),
    _useState4 = _slicedToArray(_useState3, 2),
    offsetMouseCoord = _useState4[0],
    setOffsetMouseCoord = _useState4[1];
  var _useState5 = useState([0, 0]),
    _useState6 = _slicedToArray(_useState5, 2),
    clientMouseCoord = _useState6[0],
    setClientMouseCoord = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    contextCoord = _useState8[0],
    setContextCoord = _useState8[1];
  var model = props.model,
    children = props.children;
  var TooltipComponent = model.TooltipComponent,
    DisplayMessageComponent = model.DisplayMessageComponent,
    contextMenuItems = model.contextMenuItems,
    height = model.height,
    setContextMenuFeature = model.setContextMenuFeature;
  return React.createElement("div", {
    ref: ref,
    "data-testid": "display-".concat(getConf(model, 'displayId')),
    className: classes.display,
    onContextMenu: function onContextMenu(event) {
      event.preventDefault();
      if (contextCoord) {
        // There's already a context menu open, so close it
        setContextCoord(undefined);
      } else if (ref.current) {
        setContextCoord([event.clientX, event.clientY]);
      }
    },
    onMouseMove: function onMouseMove(event) {
      if (!ref.current) {
        return;
      }
      var rect = ref.current.getBoundingClientRect();
      var left = rect.left,
        top = rect.top;
      setOffsetMouseCoord([event.clientX - left, event.clientY - top]);
      setClientMouseCoord([event.clientX, event.clientY]);
      setClientRect(rect);
    }
  }, DisplayMessageComponent ? React.createElement(DisplayMessageComponent, {
    model: model
  }) : React.createElement(LinearBlocks, _objectSpread({}, props)), children, React.createElement(TooltipComponent, {
    model: model,
    height: height,
    offsetMouseCoord: offsetMouseCoord,
    clientMouseCoord: clientMouseCoord,
    clientRect: clientRect,
    mouseCoord: offsetMouseCoord
  }), React.createElement(Menu, {
    open: Boolean(contextCoord) && Boolean(contextMenuItems().length),
    onMenuItemClick: function onMenuItemClick(_, callback) {
      callback();
      setContextCoord(undefined);
    },
    onClose: function onClose() {
      setContextCoord(undefined);
      setContextMenuFeature(undefined);
    },
    TransitionProps: {
      onExit: function onExit() {
        setContextCoord(undefined);
        setContextMenuFeature(undefined);
      }
    },
    anchorReference: "anchorPosition",
    anchorPosition: contextCoord ? {
      top: contextCoord[1],
      left: contextCoord[0]
    } : undefined,
    style: {
      zIndex: theme.zIndex.tooltip
    },
    menuItems: contextMenuItems()
  }));
});
export default BaseLinearDisplay;
export { Tooltip, BlockMsg };